/***
 * 設定產品列表高度
 */
export function modifyProductViewHeightSupport(num) {
  setTimeout(function () {
    var itemBox = document.querySelector(`.item_box_${num}`);
    var theme_content = document.querySelector(".theme_content");
    theme_content.style.height = itemBox.offsetHeight + "px";
    window.history.pushState(null, null, window.location.pathname);
  }, 500);
}
